<template>
  <section id="vision" class="vision container main">
        <div class="wrapper two-col">
          <h2 class="left" data-aos="fade-right">
              <SvgTitle class="hideSp"/>
              <SvgTitleSp class="hidePc" />
              <caption>MISSION LEADS IDEA</caption></h2>
          <div class="text-box right" data-aos="fade-up">
            <h3>アイディアはミッションが導く。</h3>
            <p>私たちが感じる日常の様々な「問題」、<br class="spacing">
              それらを解決するには「アイディア」が必要です。<br class="spacing">
              例えば、それは「For good=人や世の中の状況を良くしていくコミニケーション」の<br class="spacing">
              視点を持つことで問題解決の糸口を見つけることができます。<br class="spacing">
              これまで、クリエイティブディレクター、アートディレクターは、<br class="spacing">
              「商品をより良く見せ売上に繋げる仕事」だったり、<br class="spacing">
              「企業の取組みを良く見せイメージを上げていく仕事」をしてきました。<br class="spacing">
              しかし、これからの時代「For Good」の視点を持つコミュニケーション設計が<br class="spacing">
              社会に受け入れられる一番大切なポイントだと考えます。</p>
          </div>
        </div>    
    </section>
</template>

<script>
import SvgTitle from '@/assets/icon/h2/vision.svg?inline'
import SvgTitleSp from '@/assets/icon/h2/vision_sp.svg?inline'

export default {
  name: 'section-vision',
  components: {
      SvgTitle,
      SvgTitleSp
  }
}
</script>

<style lang="scss">

#vision{
    padding-top: 120px;
    .wrapper{
        h3{
            margin-top: -0.54em;
            @media #{$maxL}{
                margin-top: 0;
            }
        }
        .left{
            width: 24.46%;
            padding-right: calc(9.84vw - 57px);
            @media #{$IE}{
                width: 226px;
                svg{
                    width: 226px;
                    height: 240px;
                }
            }
                
            @media #{$maxL}{
                width: 100%;
                height: 19.666vw;
                padding: 0;
                margin: 0;
                margin-bottom: 36px;
                max-height: 138px;
                    svg{
                        height: 100%;
                        width: auto;
                    }
            }
        }
        .right{
            width: 70%;
            @media #{$maxL}{
                width: 100%;
            }
        }

    }
}
</style>
